// extracted by mini-css-extract-plugin
export default {"container":"PY-z","list":"QY-z"};